import React from "react";
import { Paragraph, Title } from "@sicredi/react";

import "./index.scss";

export const ServiceChannel: React.FC = () => {
  return (
    <section className="service-channel-section">
      <div className="service-channel-content">
        <Title className="service-channel-subtitle" as="h2">
          Canal de atendimento ao titular
        </Title>
        <Paragraph className="paragraph">
          <a
            className="highlight-green bold-text"
            href="https://www.sicredi.com.br/site/protecao-e-privacidade/requisicao-de-titular/"
            target="_blank"
            rel="noreferrer"
          >
            Exerça seus direitos em relação aos seus dados pessoais.
          </a>
        </Paragraph>
        <Paragraph className="paragraph">
          <span className="bold-text">Associado</span>: você também pode
          solicitar via Internet Banking ou Aplicativo Sicredi - Mobi (Menu &gt;
          Meu perfil &gt; Privacidade de dados).
        </Paragraph>

        <Paragraph className="paragraph">
          <span className="bold-text">Via Sicredi Fone</span>: 0800 724 4770,
          selecionando as opções{" "}
          <span className="bold-text">
            8 - 6 para associados e não associados
          </span>
          .
        </Paragraph>
      </div>
      <div className="service-channel-image">
        <figure className="service-channel-figure">
          <picture className="service-channel-picture">
            <img
              src="https://web-static-stage.sicredi.io/lgpd-politica-privacidade-lib@1.0.0-rc.2/images/canal_atendimento.jpg"
              alt="canal_atendimento"
              className="service-channel-image-src"
            />
          </picture>
        </figure>
      </div>
    </section>
  );
};

export default ServiceChannel;
